module.exports = __webpack_public_path__ + "img/afternoon.5fd3ab73.svg";